import jalaali from "jalaali-js";

const ToJalaali = (dateString) => {
   if (!dateString) return "";
      const date = new Date(dateString);
   // تبدیل تاریخ میلادی به شمسی
   const jalaaliDate = jalaali.toJalaali(date);
   // دریافت ساعت و دقیقه
   const hours = date.getHours().toString().padStart(2, "0");
   const minutes = date.getMinutes().toString().padStart(2, "0");

   return `${jalaaliDate.jy}/${jalaaliDate.jm}/${jalaaliDate.jd} - ${hours}:${minutes}`;

}

export default ToJalaali


